import { DropdownOption } from "@agilant/toga-blox/dist/components/SearchInput/SearchNumberInput";

export interface FilterConfig {
	filterIcon: string;
	filterWeight: string;
	isBoolean?: boolean;
	inputType: "text" | "number" | "date" | "boolean" | "multiSelect";
	dropDownOptions: DropdownOption[];
	hasToggle?: boolean;
}

export default function getFilterConfigByType(
	columnType: string | null | undefined,
	configMap: Record<string, FilterConfig>
): FilterConfig {
	const safeType = (columnType || "DEFAULT").toUpperCase();
	return configMap[safeType] || configMap.DEFAULT;
}
